// extracted by mini-css-extract-plugin
export default {"container":"PageHeader_container__yMBjO","content":"PageHeader_content__Ecjki","icon":"PageHeader_icon__epKdz"};